import _regenerator from "/Users/ahmerafzal/Documents/Work/Brandripplr/v2/project/brandripplr/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/ahmerafzal/Documents/Work/Brandripplr/v2/project/brandripplr/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
var _store$currentBrand;
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import { reactive } from "vue";
import { BrandService } from "@/services/brand.service";
import { store } from "@/stores/store";
import { UsersService } from "@/services/users.service";
import { ClientService } from "@/services/client.service";
import { router } from "@/router";
export var selectBrandDialog = reactive({
  showDialog: false,
  selectedBrandId: (_store$currentBrand = store.currentBrand) === null || _store$currentBrand === void 0 ? void 0 : _store$currentBrand.id,
  selectedBrand: store.currentBrand
});
export var closeSelectBrandDialog = function closeSelectBrandDialog() {
  selectBrandDialog.showDialog = false;
};
export var openSelectBrandDialog = function openSelectBrandDialog() {
  selectBrandDialog.showDialog = true;
};
export default {
  data: function data() {
    var searchBrand = this.debounce(this.getBrands, 500);
    return {
      loading: false,
      search_loading: false,
      data_loaded: false,
      filter: {
        search_brand_name: ""
      },
      orderBy: {
        field: "brand_name",
        order: "asc"
      },
      brands: null,
      count: 0,
      store: store,
      searchBrand: searchBrand,
      selectBrandDialog: selectBrandDialog
    };
  },
  methods: {
    selectBrand: function selectBrand(brand) {
      console.log(brand);
      this.selectBrandDialog.selectedBrand = brand;
      this.selectBrandDialog.selectedBrandId = brand.id;
    },
    changeCurrentBrand: function changeCurrentBrand() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this.loading = true;
              store.currentBrand = _this.selectBrandDialog.selectedBrand;
              _context.n = 1;
              return UsersService.updateUser({
                id: store.currentUser.id,
                current_brand_id: _this.selectBrandDialog.selectedBrand.id
              });
            case 1:
              _this.$toast.add({
                severity: "success",
                summary: "Success",
                detail: "Brand changed successfully",
                life: 5000
              });
              router.push({
                name: "index"
              });
              closeSelectBrandDialog();
              _this.loading = false;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    getBrands: function getBrands() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var current_user_type, _yield$BrandService$g, data, count, error, _yield$ClientService$, client, _error, client_brands;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _this2.search_loading = true;
              current_user_type = store.currentUser.user_type;
              if (!(current_user_type == "staff")) {
                _context2.n = 2;
                break;
              }
              _context2.n = 1;
              return BrandService.getBrands(_this2.filter, _this2.orderBy, 0);
            case 1:
              _yield$BrandService$g = _context2.v;
              data = _yield$BrandService$g.data;
              count = _yield$BrandService$g.count;
              error = _yield$BrandService$g.error;
              if (error) {
                _this2.$toast.add({
                  severity: "error",
                  summary: "Error",
                  detail: error,
                  life: 5000
                });
              } else {
                if (data) {
                  _this2.brands = data;
                } else {
                  _this2.brands = null;
                }
                _this2.count = count;
              }
              _context2.n = 4;
              break;
            case 2:
              _context2.n = 3;
              return ClientService.getClient(store.currentUser.id);
            case 3:
              _yield$ClientService$ = _context2.v;
              client = _yield$ClientService$.client;
              _error = _yield$ClientService$.error;
              if (_error) {
                _this2.$toast.add({
                  severity: "error",
                  summary: "Error",
                  detail: _error,
                  life: 5000
                });
              }
              if (client) {
                client_brands = client.client_brands;
                if (client_brands.length == 0) {
                  _this2.brands = null;
                } else {
                  _this2.brands = client_brands.map(function (client_brand) {
                    return client_brand.brand;
                  });
                  _this2.count = _this2.brands.length;
                }
              }
            case 4:
              _this2.search_loading = false;
              _this2.data_loaded = true;
            case 5:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    debounce: function debounce(func, delay) {
      var timerId;
      return function () {
        var _this3 = this;
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        if (timerId) {
          clearTimeout(timerId);
        }
        timerId = setTimeout(function () {
          func.apply(_this3, args);
          timerId = null;
        }, delay);
      };
    }
  },
  watch: {
    "selectBrandDialog.showDialog": {
      handler: function () {
        var _handler = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(val) {
          var _store$currentBrand2;
          return _regenerator().w(function (_context3) {
            while (1) switch (_context3.n) {
              case 0:
                if (!val) {
                  _context3.n = 2;
                  break;
                }
                this.filter.search_brand_name = "";
                this.data_loaded = false;
                _context3.n = 1;
                return this.getBrands();
              case 1:
                this.selectBrandDialog.selectedBrandId = (_store$currentBrand2 = store.currentBrand) === null || _store$currentBrand2 === void 0 ? void 0 : _store$currentBrand2.id;
                this.selectBrandDialog.selectedBrand = store.currentBrand;
              case 2:
                return _context3.a(2);
            }
          }, _callee3, this);
        }));
        function handler(_x) {
          return _handler.apply(this, arguments);
        }
        return handler;
      }(),
      immediate: true
    }
  }
};